/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useLayoutEffect } from "react";
import {
  MdArrowDropUp,
  MdArrowDropDown,
  MdKeyboardArrowRight,
} from "react-icons/md";

import { AiOutlineStar } from "react-icons/ai";
import { Modal } from "react-bootstrap";
import explorers from "../Image/explorer.png";
import coin from "../Image/coin.png";

import { BsInfoCircle } from "react-icons/bs";
import shares from "../Image/shares.png";

import communitys from "../Image/community.png";
import websites from "../Image/website.png";
import whitepapers from "../Image/whitepaper.png";
import dollar from "../Image/dollar.png";
import Footer from "./Footer";
import stars from "../Image/stars.png";
import Navbar from "./Navbar";
import PriceChart from "./Price_Chart";
import { Tooltip } from "antd";
import { Link, useParams } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import axios from "axios";
import { geckoGet } from "../../service/gecko";
import { fetchBep20Info } from "../../service/bscToken";
import Disqus from "./Disqus";

const notify = (msg) => toast.success(msg);
const notifyError = (msg) => toast.error(msg);
const notifyMessage = (msg) => toast(msg, { duration: 10000 });

const ICUSD_TOKEN_ADDRESS = "0xe05D4c8A972Ee90478861F2c87296bB190adB0b8";
const ICUSD_POOL_ADDRESS =
  "0x8b74f51ee97c5cfa299f83257ff2aeda927982d95e0ecb1c9c172bbd631babf9";
const ICUSD_BSCSCAN =
  "https://bscscan.com/token/0xe05d4c8a972ee90478861f2c87296bb190adb0b8";
const ICUSD_WEBSITE = "https://infinnity.capital";
const ICUSD_GECKOTERMINAL = `https://www.geckoterminal.com/bsc/pools/${ICUSD_POOL_ADDRESS}`;
const ICUSD_LOGO = require("../Image/icusd.png");

function ICUSD_Details({ url, Dissconnect, Metamask, WalletC }) {
  const [show2, setShow2] = useState(false);
  const handleClose2 = () => setShow2(false);
  const handleShow2 = () => setShow2(true);

  const [project_name] = useState("ICUSD");
  const [project_ticker_symbol] = useState("ICUSD");
  const [link_logo] = useState(ICUSD_LOGO);

  const [price, setPrice] = useState(null);
  const [price24h, setPrice24h] = useState(null);
  const [volume24h, setVolume24h] = useState(null);
  const [market_cap, setMarketCap] = useState(null);
  const [circulating_supply, setCirculatingSupply] = useState(null);
  const [total_supply, setTotalSupply] = useState(null);

  const [coinPrice, setCoinPrice] = useState("");
  const [usdValue, setUsdValue] = useState("");

  const [highlight, sethighlight] = useState("light-theme");
  const [base, setbase] = useState("light-theme");
  const [theme, setTheme] = useState("");

  useLayoutEffect(() => {
    const data = window.localStorage.getItem("theme");
    if (data === "dark-theme") {
      sethighlight("#444");
      setbase("#202020");
      setTheme("dark");
    } else {
      sethighlight("#d1d1d1");
      setbase("#efecec");
      setTheme("light");
    }
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await geckoGet(
          `https://api.geckoterminal.com/api/v2/networks/bsc/pools/${ICUSD_POOL_ADDRESS}`,
          { headers: { Accept: "application/json;version=20230302" } },
        );
        const attrs = res.data?.data?.attributes;
        if (attrs) {
          const livePrice = parseFloat(attrs.base_token_price_usd) || 0;
          const liveChange =
            parseFloat(attrs.price_change_percentage?.h24) || 0;
          const vol = parseFloat(attrs.volume_usd?.h24) ?? 0;
          const fdv = parseFloat(attrs.fdv_usd) || 0;
          const mcap = parseFloat(attrs.market_cap_usd) || fdv || 0;
          setPrice(livePrice);
          setPrice24h(liveChange);
          setVolume24h(vol);
          setMarketCap(mcap);
          // derive total supply from FDV / price
          if (fdv > 0 && livePrice > 0) {
            const supply = Math.round(fdv / livePrice);
            setTotalSupply(supply);
            setCirculatingSupply(supply);
          }
        }
      } catch (err) {
        // Fall back to token pools endpoint
        try {
          const res2 = await geckoGet(
            `https://api.geckoterminal.com/api/v2/networks/bsc/tokens/${ICUSD_TOKEN_ADDRESS}/pools?page=1`,
            { headers: { Accept: "application/json;version=20230302" } },
          );
          const pools = res2.data?.data;
          if (pools && pools.length > 0) {
            const attrs = pools[0].attributes;
            const livePrice2 = parseFloat(attrs.base_token_price_usd) || 0;
            const fdv2 = parseFloat(attrs.fdv_usd) || 0;
            const vol2 = parseFloat(attrs.volume_usd?.h24) ?? 0;
            setPrice(livePrice2);
            setPrice24h(parseFloat(attrs.price_change_percentage?.h24) || 0);
            setVolume24h(vol2);
            setMarketCap(parseFloat(attrs.market_cap_usd) || fdv2 || 0);
            if (fdv2 > 0 && livePrice2 > 0) {
              const supply2 = Math.round(fdv2 / livePrice2);
              setTotalSupply(supply2);
              setCirculatingSupply(supply2);
            }
          }
        } catch (err2) {
          console.error("Error fetching ICUSD data:", err2);
        }
      }
    };
    fetchData();
  }, []);

  // Total supply straight from the contract (Ankr BSC RPC)
  useEffect(() => {
    fetchBep20Info(ICUSD_TOKEN_ADDRESS).then((info) => {
      if (info?.totalSupply > 0) {
        setTotalSupply(info.totalSupply);
        setCirculatingSupply(info.totalSupply);
      }
    });
  }, []);

  const handleCoinPriceChange = (e) => {
    const val = e.target.value.replace(/[^0-9.]/g, "");
    setCoinPrice(val);
    setUsdValue(val * (price || 0));
  };

  const handleUsdValueChange = (e) => {
    const val = e.target.value.replace(/[^0-9.]/g, "");
    setUsdValue(val);
    setCoinPrice(price ? val / price : 0);
  };

  const copyTextToClipboard = (text) => {
    notify("copied");
    return navigator.clipboard.writeText(`${text}`);
  };

  const addrString = localStorage.getItem("address");
  let addr = null;
  if (addrString !== null) {
    try {
      addr = JSON.parse(addrString);
    } catch (_) {}
  }

  const handleSubmitnft_watchlist = () => {
    notifyMessage("Please log in to use the watchlist.");
  };

  const delete_watchlist = () => {
    notifyMessage("Please log in to use the watchlist.");
  };

  const [watchlist_star] = useState(false);

  const Market_Cap_tooltip = (
    <div className="p-y-1">
      <div className="m-b-1">
        The total market value of a cryptocurrency's circulating supply. It is
        analogous to the free-float capitalization in the stock market.
      </div>
      <div>Market cap = Current price x Circulating supply</div>
    </div>
  );

  const volume_market_tooltip = (
    <div className="p-y-1">
      <div className="m-b-1">
        Indicator of liquidity. The higher the ratio, the more liquid the
        cryptocurrency is.
      </div>
      <div>
        Cryptocurrencies with a low ratio are less liquid and most likely
        present less stable markets.
      </div>
    </div>
  );

  const fmt = (n, min = 2, max = 6) =>
    n !== null && n !== undefined
      ? Number(n).toLocaleString("en-US", {
          minimumFractionDigits: min,
          maximumFractionDigits: max,
        })
      : null;

  return (
    <>
      <SkeletonTheme baseColor={base} highlightColor={highlight}>
        <Navbar
          Dissconnect={Dissconnect}
          Metamask={Metamask}
          WalletC={WalletC}
        />
        <Toaster />

        <div className="container-kws">
          <div className="m-t-2">
            <span>
              <Link to="/">
                Cryptocurrencies <MdKeyboardArrowRight />
                {project_name}
              </Link>
            </span>{" "}
            <span>
              <MdKeyboardArrowRight /> {project_ticker_symbol}
            </span>
          </div>

          <div className="row">
            {/* Left column — logo + links */}
            <div className="col-12 col-sm-12 col-md-4 col-lg-4 m-y-1 f-w-i">
              <div className="d-f a-i-c flex-wrap f-w-i">
                <img
                  src={link_logo}
                  alt="ICUSD logo"
                  className="m-r-1 w-3 h-3 b-r-50 m-y-1"
                  onError={(e) => {
                    e.target.src = "https://via.placeholder.com/60?text=IC";
                  }}
                />
                <div className="f-w-600 f-s-2 m-r-1 m-y-1">{project_name}</div>

                <button className="bg_g_clr clr pa-5px b-r-5 b-n f-w-600 m-r-1 m-y-1">
                  {project_ticker_symbol}
                </button>

                <Tooltip title="Listing suspended">
                  <span
                    className="bg_suspended_clr pa-5px b-r-5 b-n f-w-600 m-r-1 m-y-1"
                    style={{ color: "#fff" }}
                  >
                    Suspended
                  </span>
                </Tooltip>

                {addr ? (
                  watchlist_star ? (
                    <Tooltip title="Remove from watchlist">
                      <span>
                        <button
                          className="bg_g_clr pa-5px b-r-5 b-n f-w-600 bg_g_clr_btn c-p m-r-1 m-y-1"
                          onClick={delete_watchlist}
                        >
                          <img src={stars} className="w-1_5" />
                        </button>
                      </span>
                    </Tooltip>
                  ) : (
                    <Tooltip title="Add to watchlist">
                      <span>
                        <button
                          className="bg_g_clr pa-5px b-r-5 b-n f-w-600 bg_g_clr_btn c-p m-r-1 m-y-1"
                          onClick={handleSubmitnft_watchlist}
                        >
                          <AiOutlineStar className="b-c-t f-s-18px" />
                        </button>
                      </span>
                    </Tooltip>
                  )
                ) : (
                  <button
                    className="bg_g_clr pa-5px b-r-5 b-n f-w-600 bg_g_clr_btn c-p m-r-1 m-y-1"
                    onClick={() => notifyError("You are not logged in!")}
                  >
                    <AiOutlineStar className="b-c-t f-s-18px" />
                  </button>
                )}

                <Tooltip title="Share">
                  <span>
                    <button
                      className="bg_g_clr pa-5px b-r-5 b-n f-w-600 bg_g_clr_btn c-p m-r-1 m-y-1"
                      onClick={handleShow2}
                    >
                      <img src={shares} className="b-c-t w-1_5" />
                    </button>
                  </span>
                </Tooltip>

                <div className="bg_g_clr pa-5px b-r-5 w-s-n-w m-r-1 m-y-0_5 d-f a-i-c">
                  <img src={coin} className="w-1_5" />
                  &nbsp;Coin
                </div>

                {/* Website */}
                <a href={ICUSD_WEBSITE} rel="noreferrer" target="_blank">
                  <div className="bg_g_clr bg_g_clr_btn pa-5px b-r-5 w-s-n-w m-r-1 m-y-0_5 d-f a-i-c">
                    <img src={websites} className="w-1_5" />
                    &nbsp;Website
                  </div>
                </a>

                {/* Explorer */}
                <a href={ICUSD_BSCSCAN} rel="noreferrer" target="_blank">
                  <div className="bg_g_clr bg_g_clr_btn pa-5px b-r-5 w-s-n-w m-r-1 m-y-0_5 d-f a-i-c">
                    <img src={explorers} className="w-1_5" />
                    &nbsp;Explorers
                  </div>
                </a>

                {/* GeckoTerminal */}
                <a href={ICUSD_GECKOTERMINAL} rel="noreferrer" target="_blank">
                  <div className="bg_g_clr bg_g_clr_btn pa-5px b-r-5 w-s-n-w m-r-1 m-y-0_5 d-f a-i-c">
                    &nbsp;GeckoTerminal
                  </div>
                </a>

                {/* Whitepaper */}
                <a
                  href="https://infinnity.capital/whitepaper.pdf"
                  rel="noreferrer"
                  target="_blank"
                >
                  <div className="bg_g_clr bg_g_clr_btn pa-5px b-r-5 w-s-n-w m-r-1 m-y-0_5 d-f a-i-c">
                    <img src={whitepapers} className="w-1_5" />
                    &nbsp;Whitepaper
                  </div>
                </a>

                <div className="bg_g_clr pa-5px b-r-5 w-s-n-w m-r-1 m-y-0_5 d-f a-i-c">
                  26-05-2026
                </div>
              </div>
            </div>

            {/* Right column — price stats */}
            <div className="col-12 col-sm-12 col-md-8 col-lg-8 m-y-1">
              <div className="m-t-1">
                {project_name} ({project_ticker_symbol})
              </div>
              <div className="d-f a-i-c m-t-0_5">
                <div className="m-r-1 f-s-2 f-w-600">
                  {price !== null ? (
                    `$ ${fmt(price, 6, 8)}`
                  ) : (
                    <Skeleton className="w-7" />
                  )}
                </div>
                {price24h !== null && (
                  <div className={price24h >= 0 ? "green_clr" : "red_clr"}>
                    {price24h >= 0 ? (
                      <MdArrowDropUp className="b-c-t green_f_clr" />
                    ) : (
                      <MdArrowDropDown className="b-c-t red_f_clr" />
                    )}
                    {Number(price24h).toFixed(2)}%
                  </div>
                )}
              </div>
              <hr />
              <div className="row">
                {/* Market Cap */}
                <div className="col-12 col-sm-12 col-md-4 m-b-1 b-r_1">
                  <div className="m-b-1">
                    Market Cap &nbsp;
                    <Tooltip title={Market_Cap_tooltip}>
                      <span>
                        <BsInfoCircle />
                      </span>
                    </Tooltip>
                  </div>
                  <div className="m-b-1">
                    {market_cap !== null && market_cap > 0 ? (
                      `$ ${fmt(market_cap, 0, 0)}`
                    ) : (
                      <Skeleton className="w-5" />
                    )}
                  </div>
                </div>

                {/* 24h Vol / Mkt Cap */}
                <div className="col-12 col-sm-12 col-md-4 m-b-1 b-r_1">
                  <div className="m-b-1">
                    24h Vol / Mkt Cap &nbsp;
                    <Tooltip title={volume_market_tooltip}>
                      <span>
                        <BsInfoCircle />
                      </span>
                    </Tooltip>
                    <div className="m-t-1">
                      {market_cap !== null &&
                      market_cap > 0 &&
                      volume24h !== null ? (
                        `${((volume24h / market_cap) * 100).toFixed(2)}%`
                      ) : market_cap === null ? (
                        <Skeleton className="w-3" />
                      ) : (
                        "N/A"
                      )}
                    </div>
                  </div>
                </div>

                {/* 24h Volume */}
                <div className="col-12 col-sm-12 col-md-4 m-b-1">
                  <div className="m-b-1">
                    24h Volume &nbsp;
                    <Tooltip title="A measure of how much of a cryptocurrency was traded in the last 24 hours.">
                      <span>
                        <BsInfoCircle />
                      </span>
                    </Tooltip>
                  </div>
                  <div className="m-b-1">
                    {volume24h !== null ? (
                      `$ ${fmt(volume24h, 0, 0)}`
                    ) : (
                      <Skeleton className="w-5" />
                    )}
                  </div>
                </div>

                <hr />

                {/* Circulating Supply */}
                <div className="col-12 col-sm-12 col-md-4 m-b-1 b-r_1">
                  <div className="m-b-1">
                    Circulating Supply &nbsp;
                    <Tooltip title="The amount of coins that are circulating in the market and are in public hands.">
                      <span>
                        <BsInfoCircle />
                      </span>
                    </Tooltip>
                  </div>
                  <div className="m-b-1">
                    {circulating_supply !== null && circulating_supply > 0 ? (
                      `${fmt(circulating_supply, 0, 0)} ICUSD`
                    ) : circulating_supply === null ? (
                      <Skeleton className="w-5" />
                    ) : (
                      "N/A"
                    )}
                  </div>
                </div>

                {/* FDV */}
                <div className="col-12 col-sm-12 col-md-4 m-b-1 b-r_1">
                  <div className="m-b-1">
                    Fully Diluted Valuation &nbsp;
                    <Tooltip title="FDV = Current Price x Total Supply">
                      <span>
                        <BsInfoCircle />
                      </span>
                    </Tooltip>
                  </div>
                  <div className="m-b-1">
                    {market_cap !== null && market_cap > 0 ? (
                      `$ ${fmt(market_cap, 0, 0)}`
                    ) : market_cap === null ? (
                      <Skeleton className="w-5" />
                    ) : (
                      "N/A"
                    )}
                  </div>
                </div>

                {/* Total Supply */}
                <div className="col-12 col-sm-12 col-md-4 m-b-1">
                  <div className="m-b-1">
                    Total Supply &nbsp;
                    <Tooltip title="The amount of coins that have already been created, minus any coins that have been burned.">
                      <span>
                        <BsInfoCircle />
                      </span>
                    </Tooltip>
                  </div>
                  <div className="m-b-1">
                    {total_supply !== null && total_supply > 0 ? (
                      `${fmt(total_supply, 0, 0)} ICUSD`
                    ) : total_supply === null ? (
                      <Skeleton className="w-5" />
                    ) : (
                      "N/A"
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr />
        <div className="container-kws">
          <div className="d-f flex-wrap a-i-c p-y-1">
            <div className="m-r-1 bg_b_clr pa-5px b-r-5 c-w">Overview</div>
          </div>
        </div>
        <hr />

        <div className="container-kws">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-8 m-y-1">
              <PriceChart
                api={null}
                staticPrice={price || 0}
                staticTotalSupply={0}
              />

              {/* Converter */}
              <div className="m-t-3 m-b-3">
                <div className="">{project_ticker_symbol} to USD Converter</div>
                <div className="bg_violet b-r-15">
                  <div className="row a-i-c m-t-1 pa-2 p-y-2">
                    <div className="col">
                      <div className="d-f a-i-c w-100">
                        <img
                          src={link_logo}
                          className="w-2 h-2 b-r-50 m-r-1"
                          alt=""
                          onError={(e) => {
                            e.target.src =
                              "https://via.placeholder.com/40?text=IC";
                          }}
                        />
                        <div className="f-s-0_8 w-100">
                          <input
                            type="text"
                            className="b-n pa-0_5 w-100 b-r-5"
                            placeholder="Enter amount"
                            value={coinPrice}
                            onChange={handleCoinPriceChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="d-f a-i-c w-100">
                        <img
                          src={dollar}
                          className="w-2 h-2 b-r-50 m-r-1"
                          alt=""
                        />
                        <div className="f-s-0_8 w-100">
                          <input
                            type="text"
                            className="b-n pa-0_5 w-100 b-r-5"
                            placeholder="USD value"
                            value={usdValue}
                            onChange={handleUsdValueChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* About section */}
              <div className="m-t-3 m-b-3">
                <div className="f-w-600 f-s-1_5 m-b-1">About ICUSD</div>
                <p>
                  ICUSD is a BEP-20 token deployed on Binance Smart Chain (BSC)
                  by Infinnity Capital. Visit{" "}
                  <a href={ICUSD_WEBSITE} target="_blank" rel="noreferrer">
                    {ICUSD_WEBSITE}
                  </a>{" "}
                  for more information.
                </p>
                <div className="m-t-1">
                  <strong>Contract Address:</strong>{" "}
                  <a href={ICUSD_BSCSCAN} target="_blank" rel="noreferrer">
                    {ICUSD_TOKEN_ADDRESS}
                  </a>{" "}
                  <button
                    className="b-c-t b-n c-p"
                    onClick={() => copyTextToClipboard(ICUSD_TOKEN_ADDRESS)}
                  >
                    📋
                  </button>
                </div>
                <div className="m-t-1">
                  <strong>Blockchain:</strong> Binance Smart Chain (BEP-20)
                </div>
              </div>

              <Disqus />
            </div>

            {/* Right sidebar */}
            <div className="col-12 col-sm-12 col-md-4 m-y-1">
              <div
                className="pa-1 b-r-10"
                style={{ border: "1px solid #e0e0e0" }}
              >
                <div className="f-w-600 m-b-1">ICUSD Info</div>
                <div className="d-f j-c-s-b m-b-0_5">
                  <span>Website</span>
                  <a href={ICUSD_WEBSITE} target="_blank" rel="noreferrer">
                    infinnity.capital
                  </a>
                </div>
                <div className="d-f j-c-s-b m-b-0_5">
                  <span>Explorer</span>
                  <a href={ICUSD_BSCSCAN} target="_blank" rel="noreferrer">
                    BscScan
                  </a>
                </div>
                <div className="d-f j-c-s-b m-b-0_5">
                  <span>GeckoTerminal</span>
                  <a
                    href={ICUSD_GECKOTERMINAL}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Pool
                  </a>
                </div>
                <div className="d-f j-c-s-b m-b-0_5">
                  <span>Whitepaper</span>
                  <a
                    href="https://infinnity.capital/whitepaper.pdf"
                    target="_blank"
                    rel="noreferrer"
                  >
                    View PDF
                  </a>
                </div>
                <hr />
                <div className="d-f j-c-s-b m-b-0_5">
                  <span>Chain</span>
                  <span>BEP-20 (BSC)</span>
                </div>
                <div className="d-f j-c-s-b m-b-0_5">
                  <span>Contract</span>
                  <Tooltip title={ICUSD_TOKEN_ADDRESS}>
                    <span
                      className="c-p"
                      style={{
                        maxWidth: 120,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: "inline-block",
                      }}
                      onClick={() => copyTextToClipboard(ICUSD_TOKEN_ADDRESS)}
                    >
                      {ICUSD_TOKEN_ADDRESS.slice(0, 8)}...
                      {ICUSD_TOKEN_ADDRESS.slice(-6)}
                    </span>
                  </Tooltip>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </SkeletonTheme>

      {/* Share Modal */}
      <Modal show={show2} onHide={handleClose2} centered>
        <Modal.Body>
          <div className="f-w-600 m-b-1">Share ICUSD</div>
          <div className="d-f a-i-c">
            <input
              className="b-n pa-0_5 w-100 b-r-5"
              style={{ border: "1px solid #ccc" }}
              readOnly
              value={window.location.href}
            />
            <button
              className="b-c-t b-n c-p m-l-1"
              onClick={() => {
                copyTextToClipboard(window.location.href);
                handleClose2();
              }}
            >
              📋 Copy
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ICUSD_Details;
